import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import { useStyles } from "../../../../Component/CSS/SearchFilterStyle.css";

class SearchFilterUser extends Component {
  render() {
    const { classes, data, handleChange } = this.props;
    return (
      <div>
        <div style={{ fontSize: 16 }}>Search By</div>
        <div className={classes.fieldStyle}>
          <TextField
            name="firstName"
            type="text"
            label="First Name"
            margin="normal"
            variant="outlined"
            fullWidth
            placeholder="Search by user's first name"
            style={{ marginRight: 10 }}
            InputProps={{
              classes: {
                root: classes.inputroot,
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.firstName}
            onChange={handleChange}
          />
          <TextField
            name="lastName"
            type="text"
            label="Last Name"
            margin="normal"
            variant="outlined"
            fullWidth
            placeholder="Search by user's last name"
            InputProps={{
              classes: {
                root: classes.inputroot,
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.lastName}
            onChange={handleChange}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(SearchFilterUser);
